<div class="grid-1col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-text-input [form]="form" id="code" [prefix]="prefix"></app-text-input>
    <app-text-input [form]="form" id="description" [prefix]="prefix"></app-text-input>
</div>
